goog.provide('el8.appchart.dialog.editReportDetails');

goog.require('el8.app.shared.dialog.addEditDocTag');
goog.require('el8.app.shared.tagInputOpts');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.reportTypes');
goog.require('el8.template.appchart.dialog.editReportDetails');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');

/**
 * A dialog for editing a report's document date, report type, tile, and tags
 */
el8.appchart.dialog.editReportDetails = (function() {

    var reportId = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Report Details',
        autoHeight: true,
        position: 'center',
        width: 400,
        contentFn: el8.template.appchart.dialog.editReportDetails.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'documentDate',
                datePickerOpts: {},
                validate: {
                    required: true
                }
            },
            {
                name: 'reportType'
            },
            {
                name: 'customTitle',
                maxLength: 255
            },
            {
                name: 'docTags',
                selector: '.doctags-holder',
                infoText: 'add a tag...',
                maxLength: 100,
                tagInputOpts: el8.app.shared.tagInputOpts.codedDocumentTags()
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addSaveButton(saveFn, true);
    form.addDiscardChangesButton(function(_form) {
        el8.appservice.notifier.notify('Changes discarded');
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(report) {
        super_show.call(that);
        reportId = report.getId();

        updateReportTypeSelect(report.getReportType());

        if (report.getReportType() === 'lab' && report.hasGrids()) {
            form.hideField('reportType');
        } else {
            form.showField('reportType');
        }

        var customTitle = report.getCustomTitle() ?
            report.getCustomTitle() :
            report.getClientGeneratedTitle();
        form.populate({
            documentDate: report.getDocumentDate().asString(),
            reportType: report.getReportType(),
            customTitle: customTitle
        });
        form.getTagInput('docTags').setTags(report.getDocTagMaps());

        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        form.showField('reportType');
        form.reset();
        reportId = null;
    };

    function updateReportTypeSelect(currReportType) {
        var selectOpts = el8.data.reportTypes.sorted().map(function(rType) {
            return { value: rType.getClientReportTypeKey(), description: rType.getUserLabel() };
        });
        // Check if the current report type exists in the practice owned types
        var currTypeExists = selectOpts.some(function(opt) {
            return opt.value === currReportType;
        });
        // If not, append it to the selectOpts
        if (!currTypeExists) {
            selectOpts.push({
                value: currReportType,
                description: el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[currReportType].user_label
            });
        }
        form.getInputField('reportType').html(
            el8.template.appchart.dialog.editReportDetails.reportTypeOptions({
                reportTypes: selectOpts
            })
        );
        that.adjustHeight();
    }

    function saveFn() {
        if (!form.isValid()) { return; }

        var report = el8.ptdata.reports.getById(reportId);
        var oldReportType = report.getReportType();
        var oldTitle = report.getCustomTitle() ?
                    report.getCustomTitle() : report.getClientGeneratedTitle();
        var oldTagIds = report.getDocTagIds();

        var postDict = {};

        // Support grabbing the document date
        var documentDate = el8.service.tz.newTzDate(form.getVal('documentDate'));

        // Save at 00:00:00 time, unless we're today. Same logic as docMgr.Filer
        postDict['document_date'] = el8.service.tz.asServerFormatDateTime(el8.service.tz.zeroTimeIfNotToday(documentDate));

        if (oldReportType !== form.getVal('reportType')) {
            postDict['report_type'] = form.getVal('reportType');
        }
        if (oldTitle !== form.getVal('customTitle')) {
            postDict['custom_title'] = form.getVal('customTitle');
        }
        if (oldTagIds !== form.getVal('docTags')) { // two lists of IDs
            postDict['doc_tags'] = form.getVal('docTags');
        }

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('reportMetadata', [reportId]),
            data: JSON.stringify(postDict),
            success: function(data) {
                var updatedReport = el8.ptdata.reports.create(data);
                // if we changed the report type, we need to trigger an extra event
                if (postDict['report_type']) {
                    el8.ptdata.reports.trigger(EVENTS.MOVED, updatedReport, oldReportType);
                }
                that.hide();
            }
        });
    }

    return that;

})();

